import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from 'src/app/services/client/theme/theme.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { localStorageKeys } from 'src/app/services/localStorage/localStorageVariables';

@Component({
  selector: 'submit-success',
  templateUrl: './submit-success.component.html',
  styleUrls: ['./submit-success.component.scss'],
})
export class SubmitSuccessComponent implements OnInit {
  public serviceRequestId;
  public message1 = 'Thank You For Service Request';
  public message2: string;
  public message3: string;
  public validate: string;
  public storeName;
  public bookingReferenceId: any;
  public appName: string;
  public partnerId: string;

  constructor(
    private route: ActivatedRoute,
    private navController: NavController,
    private themeService: ThemeService,
    private translate: TranslateService,
    private analyticsService: AnalyticsService
  ) {}
  ngOnInit() {
    this.partnerId = this.themeService.getAppPid;
    this.appName = this.themeService.getAppName;
    this.serviceRequestId = this.route.snapshot.params.id;
    this.storeName = this.route.snapshot.params.storeName;
    this.validate = this.serviceRequestId.substring(0, 2);
    this.bookingReferenceId = this.route.snapshot.params.bookingReferenceId;
    if (this.validate === 'SR') {
      this.message1 =
        this.translate.instant(
          'page_status.submit_success.thank_you_for_booking'
        ) +
        this.appName +
        '!';
      this.message2 =
        this.translate.instant(
          'page_status.submit_success.your_booking_Id_is'
        ) +
        ' #' +
        this.serviceRequestId;
      this.message3 = this.translate.instant(
        'page_status.submit_success.we_will_confirm_avaialability'
      );
    } else if (Number(this.validate) && this.storeName) {
      // eslint-disable-next-line max-len
      this.message1 =
        this.translate.instant(
          'page_status.submit_success.thank_you_for_your_placing_your_duty_free_order_at'
        ) +
        this.storeName +
        this.translate.instant('page_status.submit_success.with') +
        this.appName;
      this.message2 =
        this.translate.instant('page_status.submit_success.our_order_Id_is') +
        ' #' +
        this.serviceRequestId;
    } else if (this.bookingReferenceId) {
      this.message1 = this.translate.instant(
        'page_status.submit_success.booking_request_submitted'
      );
      this.message2 =
        this.translate.instant(
          'page_status.submit_success.your_booking_will_be_confirmed_soon'
        ) + ' ';
    } else {
      // eslint-disable-next-line max-len
      this.message2 =
        this.translate.instant('page_status.submit_success.your_request_ID') +
        ' #' +
        this.serviceRequestId +
        ' ' +
        this.translate.instant('page_status.submit_success.is_submitted');
    }
    if (this.route.snapshot.params.txt) {
      this.message1 = decodeURIComponent(this.route.snapshot.params.txt);
    }
  }
  goToHome() {
    this.analyticsService.trackUnified('go_home_clicked', {
      flow: 'status',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      component: 'submit-success-component',
      button: 'go-to-home',
    });
    if (this.partnerId === 'ent') {
      const defaultSSOUrl = localStorage.getItem(localStorageKeys.DEFAULT_SSO_URL);
      if (defaultSSOUrl) {
        this.navController.navigateRoot(defaultSSOUrl);
        return;
      }
    }
    this.navController.navigateRoot('/home');
  }
  navigate() {
    if (!this.bookingReferenceId) {
      return;
    }

    this.analyticsService.trackUnified('view_details_clicked', {
      flow: 'status',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      component: 'submit-success-component',
      button: 'view-details',
    });
    this.navController.navigateForward(
      [
        `/flight-booking/v2/booking-confirmation/`,
        this.bookingReferenceId,
        { showSuccessModal: this.partnerId === 'bfl' ? true : false },
      ],
      { replaceUrl: true }
    );
  }
}
